export default __webpack_public_path__ + "static/media/sp-icon.4591d8a6.svg";